
import { colorProp as color } from '~/lib/utility/colors'

export default {
  name: 'MapIcon',

  props: {
    withTail: {
      type: Boolean,
      default: true
    },

    size: {
      type: String,
      default: 'md',
      validator: prop => ['xs', 'sm', 'md', 'xl'].includes(prop)
    },

    icon: {
      type: Object,
      default: null
    },

    color
  }
}
